
<template>
   <v-layout row wrap>
      <v-flex class="xs12 sm5">
         <qculist
            :questions="questions"
            :selectedQuestionId="selectedQuestionId"
            @updatedList="updatedList"
            @addQuestion="addQuestion"
            @questionSelected="questionSelected"
            @deleteQuestion="deleteQuestion">
        </qculist>
      </v-flex>

      <v-flex class="xs12 sm7">
         <router-view @createQuestion="createQuestion" @updateQuestion="updateQuestion"></router-view>
      </v-flex>
   </v-layout>
</template>


<script>
   import qculist from '@/components/nutrikiosk/QCUList'

   export default {

      props: {
         baseRoute: String,
      },

      components: {
         qculist: qculist,
      },

      mounted () {
         // fetch questions; reactivity will update question list
         this.$store.dispatch('nutrikiosk/GET_QCU_QUESTIONS')
      },

      data () {
         return {
            selectedQuestionId: null,
         }
      },

      computed: {
         questions() {
            return this.$store.getters['nutrikiosk/qcuQuestions']
         },
      },

      methods: {
         async questionSelected (questionId) {
            // select question in list
            this.selectedQuestionId = questionId
            // get associated images & items
            await this.$store.dispatch('nutrikiosk/GET_QCU_IMAGES', questionId)
            await this.$store.dispatch('nutrikiosk/GET_QCU_ITEMS', questionId)
            // change route
            this.$router.push(`${this.baseRoute}question/${questionId}`)
         },
         addQuestion () {
            this.$router.push('/qcu-editor/create')
         },
         createQuestion (question) {
            this.$store.dispatch('nutrikiosk/POST_QCU_QUESTION', question)
         },
         updateQuestion (question) {
            this.$store.dispatch('nutrikiosk/PUT_QCU_QUESTION', question)
         },
         deleteQuestion (question) {
            this.$store.dispatch('nutrikiosk/DELETE_QCU_QUESTION', question)
         },
         updatedList: function() {
            // list has been updated: unselect all & remove detail view
            this.selectedQuestionId = null
            this.$router.push('/qcu-editor/')
         },

      },
   };
</script>



// WEBPACK FOOTER //
// QCUEditor.vue?03aa335d